import { createFileRoute } from "@tanstack/react-router";
import { UserTracker } from "@/components/UserTracker";

export const Route = createFileRoute("/_authenticated/logs/track/")({
  component: UserTracker,
  staticData: { page: "logs" },
});
